import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import useInvoiceService from '../hooks/useInvoiceService';
import useCertificationService from '../hooks/useCertificationService';
import useOfferService from '../hooks/useOfferService';
import useOrderService from '../hooks/useOrderService';
import { useSnackbar } from './SnackbarProvider';
import { handleApiError, IconBtn } from './Utils';

const CreatePdf = ({
    endpoint,
    text = 'PDF',
    icon: iconProp = null,
    showLabel = false,
}) => {
    const [loading, setLoading] = useState(false);
    const { getInvoiceProformPdf, getInvoicePdf } = useInvoiceService();
    const { getCertificationPdf } = useCertificationService();
    const { getOfferPdf } = useOfferService();
    const { getOrderPdf } = useOrderService();
    const showSnackbar = useSnackbar();

    const resolvePdfCall = (endpoint) => {
        // /invoices/:id/generate-pdf/proform
        const invoiceProformMatch = endpoint.match(/^\/invoices\/([^/]+)\/generate-pdf\/proform$/);
        if (invoiceProformMatch) return () => getInvoiceProformPdf(invoiceProformMatch[1]);

        // /invoices/:id/generate-pdf/invoice
        const invoiceMatch = endpoint.match(/^\/invoices\/([^/]+)\/generate-pdf\/invoice$/);
        if (invoiceMatch) return () => getInvoicePdf(invoiceMatch[1]);

        // /certifications/:id/generate-pdf
        const certMatch = endpoint.match(/^\/certifications\/([^/]+)\/generate-pdf$/);
        if (certMatch) return () => getCertificationPdf(certMatch[1]);

        // /offers/:id/generate-pdf
        const offerMatch = endpoint.match(/^\/offers\/([^/]+)\/generate-pdf$/);
        if (offerMatch) return () => getOfferPdf(offerMatch[1]);

        // /orders/:id/generate-pdf
        const orderMatch = endpoint.match(/^\/orders\/([^/]+)\/generate-pdf$/);
        if (orderMatch) return () => getOrderPdf(orderMatch[1]);

        return null;
    };

    const showPdf = async () => {
        const pdfCall = resolvePdfCall(endpoint);
        if (!pdfCall) {
            showSnackbar(`Endpoint no reconocido: ${endpoint}`, 'error');
            return;
        }
        try {
            setLoading(true);
            const response = await pdfCall();
            const pdfUrl = URL.createObjectURL(response.data);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            showSnackbar(handleApiError(error, 'Error al generar el PDF.'), 'error');
        } finally {
            setLoading(false);
        }
    };

    if (showLabel) {
        return (
            <Button
                variant="outlined"
                size="small"
                onClick={showPdf}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={14} color="inherit" /> : (iconProp || <PictureAsPdfIcon />)}
                sx={{ minHeight: 34 }}
            >
                {text}
            </Button>
        );
    }

    return (
        <IconBtn
            icon={loading ? <CircularProgress size={20} color="inherit" /> : (iconProp || <PictureAsPdfIcon />)}
            title={text}
            onClick={showPdf}
            disabled={loading}
        />
    );
};

export default CreatePdf;
